'use client'

import { useEffect, useState } from 'react'
import {
  ArrowDownIcon,
  Heading1Icon,
  Heading2Icon,
  Heading3Icon,
  Heading4Icon,
  Heading5Icon,
  Heading6Icon,
  HeadingIcon,
  PilcrowIcon
} from 'lucide-react'
import { useEditorContext } from '@/components/ui/editor'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

const Heading = () => {
  const { editor, sourceMode } = useEditorContext()

  const [selectionStates, setSelectionStates] = useState({
    heading1: false,
    heading2: false,
    heading3: false,
    heading4: false,
    heading5: false,
    heading6: false
  })

  useEffect(() => {
    if (!editor) {
      return
    }

    const updateSelection = () => {
      setSelectionStates({
        heading1: editor.isActive('heading', { level: 1 }),
        heading2: editor.isActive('heading', { level: 2 }),
        heading3: editor.isActive('heading', { level: 3 }),
        heading4: editor.isActive('heading', { level: 4 }),
        heading5: editor.isActive('heading', { level: 5 }),
        heading6: editor.isActive('heading', { level: 6 })
      })
    }

    editor.on('selectionUpdate', updateSelection)
    editor.on('transaction', updateSelection)

    // cleanup
    return () => {
      editor.off('selectionUpdate', updateSelection)
      editor.off('transaction', updateSelection)
    }
  }, [editor])

  return (
    <DropdownMenu>
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <DropdownMenuTrigger asChild>
              <Button type="button" size="sm" variant="ghost" disabled={sourceMode} tabIndex={-1}>
                <HeadingIcon />
                <ArrowDownIcon />
              </Button>
            </DropdownMenuTrigger>
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>Heading</p>
        </TooltipContent>
      </Tooltip>
      <DropdownMenuContent align="start">
        <DropdownMenuItem
          className={!Object.values(selectionStates).some(Boolean) ? 'bg-gray-100 dark:bg-gray-800' : ''}
          onClick={() => editor.chain().focus().setParagraph().run()}>
          <PilcrowIcon />
          <span>Normal</span>
        </DropdownMenuItem>
        <DropdownMenuItem
          className={selectionStates.heading1 ? 'bg-gray-100 dark:bg-gray-800' : ''}
          onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}>
          <Heading1Icon />
          <span>Heading 1</span>
        </DropdownMenuItem>
        <DropdownMenuItem
          className={selectionStates.heading2 ? 'bg-gray-100 dark:bg-gray-800' : ''}
          onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}>
          <Heading2Icon />
          <span>Heading 2</span>
        </DropdownMenuItem>
        <DropdownMenuItem
          className={selectionStates.heading3 ? 'bg-gray-100 dark:bg-gray-800' : ''}
          onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()}>
          <Heading3Icon />
          <span>Heading 3</span>
        </DropdownMenuItem>
        <DropdownMenuItem
          className={selectionStates.heading4 ? 'bg-gray-100 dark:bg-gray-800' : ''}
          onClick={() => editor.chain().focus().toggleHeading({ level: 4 }).run()}>
          <Heading4Icon />
          <span>Heading 4</span>
        </DropdownMenuItem>
        <DropdownMenuItem
          className={selectionStates.heading5 ? 'bg-gray-100 dark:bg-gray-800' : ''}
          onClick={() => editor.chain().focus().toggleHeading({ level: 5 }).run()}>
          <Heading5Icon />
          <span>Heading 5</span>
        </DropdownMenuItem>
        <DropdownMenuItem
          className={selectionStates.heading6 ? 'bg-gray-100 dark:bg-gray-800' : ''}
          onClick={() => editor.chain().focus().toggleHeading({ level: 6 }).run()}>
          <Heading6Icon />
          <span>Heading 6</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default Heading
